import Icon from "components/Elements/Icon/Icon";
import Tooltip from "components/Elements/Tooltip/Tooltip";

import { ButtonAccessability } from "components/Elements/Button/Button";
import { memo, useCallback, useState } from "react";

import styles from "./floatingButton.module.scss";

interface FloatingButtonI extends React.HTMLAttributes<HTMLDivElement> {
  showForm: boolean;
  setShowForm: React.Dispatch<React.SetStateAction<boolean>>;
}

/**
 * FloatingButton component is a floating button that is displayed
 * on the promo page. When the user clicks on the button, the ContactUsForm
 * component is displayed.
 */
const FloatingButton = (props: FloatingButtonI) => {
  const { showForm, setShowForm, ...restProps } = props;

  const [isHovered, setIsHovered] = useState(false);

  const handleShowForm = useCallback(() => {
    setShowForm(true);
  }, [setShowForm]);

  return (
    <ButtonAccessability onClick={handleShowForm} ariaLabel="Contact Us">
      {/*@ts-ignore*/}
      <Tooltip tooltipTextKey="contact-us" id="contact-us">
        <div
          className={`${styles.wrapper} ${showForm ? styles.hidden : ""}`}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          {...restProps}
        >
          <Icon name="comment-promo" xxl white={!isHovered} blue={isHovered} />
        </div>
      </Tooltip>
    </ButtonAccessability>
  );
};

export default memo(FloatingButton);
